module.exports = __webpack_public_path__ + "app/modals/notice-delete-modal.view.html";